
export const BUILD_INFO = {
  timestamp: new Date().toISOString(),
  version: '1.0.0',
  environment: import.meta.env.MODE || 'production',
};

// Log build info in development
if (import.meta.env.DEV) {
  console.log('🏗️ Build Info:', BUILD_INFO);
  console.log('🌍 Environment Variables:', {
    mode: import.meta.env.MODE,
    dev: import.meta.env.DEV,
    prod: import.meta.env.PROD,
  });
}
